

















































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import fetch from "@/common/api/fetch";
import CONFIG from "@/common/config";
import { pickHtmlTextContent } from "@/common/utils/dealWithString";

import {
  ShareObjectInterface,
  SignatureData,
  AxiosPromiseData,
  AxiosPromiseError
} from "@/common/interface";
import { BargainParameterState } from "@/common/interface/bargain_type";

import getUrlParam from "@/common/utils/getUrlParam";
import getActivityType from "@/common/utils/getActivityType";
import { formatMoney } from "@/common/utils/format";
import { replaceString } from "@/common/utils/dealWithString";
import { exchangeMsgToXcx, wechatSignUp } from "@/common/utils/wechatFunc";
import getActivityDeadline from "@/common/utils/getActivityDeadline";

import BargainResult from "./BargainResult.vue";

@Component({
  components: {
    "bargain-result": BargainResult
  }
})
export default class BargainTitleSection extends Vue {
  @Getter("titleSection") titleSection!: object;
  @Getter("section") section!: any;
  @Getter("title") getterTitle!: string;
  @Getter("bargainParameter") bargainParameter!: BargainParameterState;
  @Getter("uid") uid!: string; // 如果用户参加了活动，uid就会有值
  @Getter("openId") openId!: string;
  @Getter("name") name!: string;
  @Getter("phone") phone!: string;
  @Getter("posterAvatar") posterAvatar!: string;
  @Getter("posterName") posterName!: string;
  @Getter("joinNumber") joinNumber!: number;
  @Getter("coverTiny") coverTiny!: string;
  @Getter("signature") signature!: SignatureData;
  @Getter("documentTitle") documentTitle!: string;
  @Getter("deadline") deadline!: number;
  @Getter("startTime") startTime!: number;
  @Getter("rankList") rankList!: Array<any>;
  @Getter("urlUid") urlUid!: string;
  @Getter("activityRule") activityRule!: string;
  @Getter("showJoinFooter") showJoinFooter!: boolean;
  @Getter("canPay") canPay!: boolean;
  @Getter("mustMinPay") mustMinPay!: boolean;
  @Getter("hasPay") hasPay!: number;
  @Getter("qrCodeUrl") qrCodeUrl!: string;
  @Getter("orgId") orgId!: string;
  @Getter("payInstId") payInstId!: string;
  @Getter("cancel") cancel!: boolean;

  @Action("changeUid") changeUid!: Function;
  @Action("changeJoinInfo") changeJoinInfo!: Function;
  @Action("changeJoinNumber") changeJoinNumber!: Function;
  @Action("changeRankList") changeRankList!: Function;
  @Action("changeUrlUid") changeUrlUid!: Function;
  @Action("changeBargainParameter") changeBargainParameter!: Function;
  @Action("changePosterName") changePosterName!: Function;
  @Action("changePosterAvatar") changePosterAvatar!: Function;
  @Action("changePosterUrl") changePosterUrl!: Function;
  @Action("changePayInstId") changePayInstId!: Function;

  cutNumber: string = "0";
  pageType: string = getUrlParam("type") as string;
  gainType: number = 1;
  bargainResultTimer: number = 0;
  show: boolean = false;
  showResult: boolean = false;
  showStar: boolean = false;

  getUrlParam: Function = getUrlParam;
  formatMoney: Function = formatMoney;

  get title(): string {
    return replaceString(this.getterTitle);
  }
  dealwithTime(activityDeadline: any) {
    const nowTimestamp: number = new Date().valueOf();
    return {
      nowTimestamp,
      activityDeadline
    };
  }
  get isActivityFinish(): boolean {
    const { nowTimestamp, activityDeadline } = this.dealwithTime(this.deadline);
    return nowTimestamp >= activityDeadline;
  }

  // 剩余天数
  get deadlineDay(): number {
    return getActivityDeadline(this.deadline).deadlineDay;
  }
  // 剩余小时
  get deadlineHour(): string | number {
    return getActivityDeadline(this.deadline).deadlineHour;
  }
  // 剩余分钟
  get deadlineMinute(): string | number {
    return getActivityDeadline(this.deadline).deadlineMinute;
  }

  get isActivityStart(): boolean {
    return new Date().valueOf() < this.startTime;
  }

  // 剩余天数
  get startTimeDay(): number {
    return getActivityDeadline(this.startTime).deadlineDay;
  }
  // 剩余小时
  get startTimeHour(): string | number {
    return getActivityDeadline(this.startTime).deadlineHour;
  }
  // 剩余分钟
  get startTimeMinute(): string | number {
    return getActivityDeadline(this.startTime).deadlineMinute;
  }

  mounted() {
    const deadlineBgDom = document.getElementsByClassName("deadline-bg")[0];
    const woyaokanjiaDom = document.getElementsByClassName("woyaokanjia")[0];
    const timer = window.setTimeout(() => {
      if (deadlineBgDom) {
        (deadlineBgDom as HTMLImageElement).style.maxHeight = "5000px";
      }

      if (woyaokanjiaDom) {
        (woyaokanjiaDom as HTMLImageElement).style.maxHeight = "5000px";
      }
    }, 1000);
  }

  handleShowJoinModal() {
    if (new Date().valueOf() < this.startTime) {
      Vue.$toast.error("活动未开始");
      return;
    }
    // 如果活动已过期，则弹窗
    if (new Date().valueOf() > Number(this.deadline)) {
      Vue.$confirm({
        oneBtn: true,
        title: '来晚啦',
        text: '活动已结束！',
        okText: '确定'
      });
      return;
    }
    const { pageType } = this;
    if (pageType !== "demo" && pageType !== "preview" && pageType !== "check") {
      Vue.$modal({
        ok: (
          name: string,
          phone: string,
          authCode: string,
          additionalInfo: string,
          instId?: string,
        ) => {
          this.joinActivity(name, phone, authCode, additionalInfo, instId);
        }
      });
    }

    try {
      // 链接上有uid为二级页面，没有则为一级页面
      // 统计一级活动页报名数
      if (!getUrlParam("uid")) {
        window.TDAPP.onEvent("一级活动页报名数", "砍价");
      } else {
        // 统计二级页面浏览数
        window.TDAPP.onEvent("二级活动页报名数", "砍价");
      }
    } catch (error) {
      throw new Error(error);
    }
  }

  joinActivity(
    name: string,
    phone: string,
    authCode: string,
    additionalInfo: string,
    instId?: string,
  ) {
    if (this.orgId && !instId) {
      Vue.$toast.error('请选择校区');
      return null;
    }
    const data = {
      name,
      instId,
      phone,
      authCode,
      additionalInfo,
      openId: this.openId,
      activityId: getUrlParam("broadcastId")
    };
    const promoterId: string = getUrlParam("promoterId") as string;
    const referralId: string = getUrlParam("referralId") as string;
    if (promoterId) {
      (data as any).promoterId = promoterId;
    }
    if (referralId) {
      (data as any).referralId = referralId;
    }

    fetch
      .newpost("anon/bargain/joinActivity", data)
      .then((res: AxiosPromiseData) => {
        const { result } = res;
        Vue.$confirm({
          oneBtn: true,
          title: "报名成功",
          text: "点击“确定”进入您的活动页面砍价吧",
          okText: "确定",
          ok: () => {
            this.changeUid({ uid: result });
            this.changeUrlUid(result);
            this.changeJoinNumber(this.joinNumber + 1);

            this.changePosterName(name);
            this.getRankList();
            this.getBargainLeader();

            const location =
              window.location.href
                .replace(/[?, &]code.*state/i, "")
                .replace(/&uid=\d*/, "") +
              "&uid=" +
              result;
            this.signatureWechatShare(location);
            exchangeMsgToXcx(result);
          }
        });
      })
      .catch((error: AxiosPromiseError) => {
        if (error.resultCode === 1402) {
          Vue.$confirm({
            oneBtn: true,
            title: "很抱歉",
            text: "活动已结束",
            okText: "确定"
          });
        } else if (error.resultCode === 1516) {
          this.changeBargainParameter({
            prizeLeftCount: 0
          });
          Vue.$confirm({
            oneBtn: true,
            title: "很抱歉",
            text: "该活动课程已被抢完",
            okText: "确定"
          });
        } else {
          Vue.$toast.error(error.resultMsg || error.message);
        }
      });
  }

  getRankList() {
    const param = {
      activityId: getUrlParam("broadcastId"),
      pageNo: 0,
      pageSize: 1000
    };
    fetch
      .newpost("anon/bargain/getRankList", param)
      .then((res: AxiosPromiseData) => {
        const { total, records, hasNext } = res.result;
        this.changeRankList(records);
      });
  }

  getBargainLeader() {
    const param = {
      activityId: getUrlParam("broadcastId"),
      userId: this.urlUid
    };
    fetch
      .newpost("anon/bargain/getBargainLeader", param)
      .then((res: AxiosPromiseData) => {
        const { result } = res;
        const { xmShowSignInVO } = result;
        const { rank, currentPrice, totalBargainTime } = result;
        const { avatar, name, phone, additionalInfo, instId } = xmShowSignInVO;
        this.changeJoinInfo({
          name,
          phone,
          signupItemConfig: additionalInfo
        });
        const parameter = {
          currentPrice: this.formatMoney(currentPrice, 100, true),
          totalBargainTime,
          currentRank: rank + 1
        };
        this.changePayInstId(instId);
        this.changeBargainParameter(parameter);
        this.changePosterAvatar(avatar);
      });
  }

  signatureWechatShare(location: string) {
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const shareUrl: string =
      (CONFIG.shareUrl as any)[env] +
      (CONFIG.appId as any)[env] +
      "&redirect_uri=" +
      encodeURIComponent(location) +
      "&response_type=code&scope=snsapi_base&state=state#wechat_redirect";
    let shareObject: ShareObjectInterface = {
      title: this.title.replace(/<br\/>/g, "\n"),
      desc: pickHtmlTextContent(this.section.prizeDesc),
      link: shareUrl,
      imgUrl: this.coverTiny
    };
    this.changePosterUrl(shareUrl);
    wechatSignUp(this.signature, shareObject);
  }

  // 砍价
  bargain() {
    const param = {
      activityId: getUrlParam("broadcastId"),
      openId: this.openId,
      leaderId: this.urlUid
    };
    fetch
      .newpost("anon/bargain/gainActivity", param)
      .then((res: AxiosPromiseData) => {
        const {
          result: { bargainGrade, bargainNumber, leftQuota }
        } = res;
        this.showResult = true;
        this.gainType = bargainGrade;
        this.cutNumber = this.formatMoney(bargainNumber, 100, true);
        this.getRankList();
        this.getBargainLeader();
        this.changeBargainParameter({ prizeLeftCount: leftQuota });

        // 控制星星图片的切换，1s换一张
        this.bargainResultTimer = window.setInterval(() => {
          this.showStar = !this.showStar;
        }, 1000);
      })
      .catch((error: AxiosPromiseError) => {
        const { code, message } = error;
        if (code === "GAIN_NOT_IN_TIME") {
          this.show = false;
          const leftTime = Math.abs(Number(message));
          let hours = Math.floor(leftTime / 1000 / 3600);
          let minutes = Math.floor(leftTime / 1000 / 60 - hours * 60);
          hours = hours < 0 ? 0 : hours;
          /**
           * hotfix:解决展示时间错误问题
           * jira:http://jira.ixm5.cn/browse/XMGJ-2898
           * 原因:向下取整，导致还有不到一分钟时，显示的时间为0时0分钟
           */
          minutes = minutes < 0 ? 0 : minutes;
          if(minutes <=0 && hours === 0){
            minutes = 1;
          }
          Vue.$confirm({
            text: `请在${hours}小时${minutes}分钟后再砍，<br />还可召集好友帮砍哦`,
            cancleText: "好的",
            okText: "找好友帮忙",
            ok: () => {
              this.handleRedirectToSharePage();
            }
          });
          return;
        }
        if (code === "BARGAIN_HELP_ALREADY") {
          this.show = false;
          if (!this.uid) {
            Vue.$confirm({
              text: "你已经帮他砍过了",
              okText: "我也要参与",
              ok: () => {
                this.handleShowJoinModal();
              }
            });
          } else {
            Vue.$confirm({
              oneBtn: true,
              text: "你已经帮他砍过了"
            });
          }
          return;
        }
        if (code === "ACTIVITY_OVERDUE") {
          this.show = false;
          Vue.$confirm({
            oneBtn: true,
            title: "很抱歉",
            text: "活动已结束",
            okText: "确定"
          });
          return;
        }
        if (code === "ACTIVITY_NUMBER_FULL") {
          this.show = false;
          this.changeBargainParameter({ prizeLeftCount: 0 });
          Vue.$confirm({
            oneBtn: true,
            title: "很抱歉",
            text: "该奖品已经被领完",
            okText: "确定"
          });
          return;
        }
        if (code === "OVER_STANDARD") {
          this.show = false;
          Vue.$confirm({
            oneBtn: true,
            title: "提示",
            text: "已砍至底价，无法继续砍价",
            okText: "确定"
          });
          return;
        }
      });

    try {
      // 统计二级活动页助力数
      window.TDAPP.onEvent("二级活动页助力数", "砍价");
    } catch (error) {
      throw new Error(error);
    }
  }

  backToMyActivity() {
    const location =
      window.location.href
        .replace(/[?,&]code.*state/i, "")
        .replace(/&uid=\d*/, "") +
      "&uid=" +
      this.uid;
    this.signatureWechatShare(location);
    exchangeMsgToXcx(this.uid);
    this.changeUrlUid(this.uid);
    this.getBargainLeader();
  }

  // 去付款
  handleToPay() {
    if (this.bargainParameter.currentPrice > this.bargainParameter.minPrice) {
      Vue.$confirm({
        text: `当前价格￥${this.bargainParameter.currentPrice}<br />  当前暂未砍至底价，是否购买？`,
        okText: "确定购买",
        cancleText: "找人帮砍",
        cancle: () => {
          this.handleRedirectToSharePage();
        },
        ok: () => {
          this.handleToPayPage();
        }
      });
    } else {
      this.handleToPayPage();
    }
  }

  handleToPayPage() {
    if (!this.uid || (this.uid && this.hasPay !== 4)) {
      if (window.__wxjs_environment === "miniprogram") {
        const promoterId = getUrlParam("promoterId");
        const referralId = getUrlParam("referralId");
        const broadcastId = getUrlParam("broadcastId");
        const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
        let qrCodeUrl = this.qrCodeUrl;
        if (env === "gray") {
          qrCodeUrl = qrCodeUrl.replace("xmshow", "xmshow/gray");
        }
        const scene =
          `openId=${
            this.openId
          }&activityId=${broadcastId}&qrCodeUrl=${encodeURIComponent(
            qrCodeUrl
          )}` +
          (this.payInstId ? `&leadersInstId=${this.payInstId}` : "") +
          (promoterId ? `&promoterId=${promoterId}` : "") +
          (referralId ? `&referralId=${referralId}` : "");

        window.wx.miniProgram.redirectTo({
          url: `/pages/pay-detail/index?${scene}`
        });
      } else {
        fetch.post("c/common/pay/appid", {}).then((res: AxiosPromiseData) => {
          const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
          const host: string = location.host;
          const tempStr: string = env === "gray" ? "/xmpay" : "/xmpay";
          const payAppId: string = res.data;

          const targetUrl: string =
            "https://" +
            host +
            tempStr +
            (env === "prod" || env === "gray" ? "/index.html" : "/") +
            "#/xmx_bargain_pay?userOpenId=" +
            this.openId +
            "&broadcastId=" +
            getUrlParam("broadcastId") +
            (getUrlParam("promoterId")
              ? "&promoterId=" + getUrlParam("promoterId")
              : "") +
            (getUrlParam("referralId")
              ? "&referralId=" + getUrlParam("referralId")
              : "");

          const url: string =
            (CONFIG.shareUrl as any)[env] +
            payAppId +
            "&redirect_uri=" +
            encodeURIComponent(targetUrl) +
            (targetUrl.indexOf("?") != -1 ? "%26" : "%3F") +
            "appid%3D" +
            payAppId +
            "&response_type=code&scope=snsapi_base&state=state#wechat_redirect";
          location.href = url;
        });
      }
    }
  }

  // 查看我的报名记录
  handleViewMyRecord() {
    if (this.canPay || this.cancel) {
      // 已报名,跳转到小程序支付结结果页面
      if (window.__wxjs_environment === "miniprogram") {
        const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
        const broadcastId = getUrlParam("broadcastId");
        let qrCodeUrl = this.qrCodeUrl;
        if (env === "gray") {
          qrCodeUrl = qrCodeUrl.replace("xmshow", "xmshow/gray");
        }
        const scene = `openId=${
          this.openId
        }&activityId=${broadcastId}&qrCodeUrl=${encodeURIComponent(qrCodeUrl)}`;

        window.wx.miniProgram.redirectTo({
          url: `/pages/pay-result/index?${scene}`
        });
      } else {
        const host: string = location.host;
        const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
        const tempStr: string = env === "gray" ? "/xmpay" : "/xmpay";

        const targetUrl: string =
          "https://" +
          host +
          tempStr +
          (env === "prod" || env === "gray" ? "/index.html" : "/") +
          "#/xmx_bargain_pay_result?userOpenId=" +
          this.openId +
          "&broadcastId=" +
          getUrlParam("broadcastId");
        location.href = targetUrl;
      }
    } else {
      Vue.$modal({
        ok: (
          name: string,
          phone: string,
          authCode: string,
          additionalInfo: string,
          instId?: string,
        ) => {
          this.joinActivity(name, phone, authCode, additionalInfo, instId);
        }
      });
    }
    
  }

  handleHideResult() {
    this.showResult = false;
  }

  // 显示/隐藏分享popup
  handleRedirectToSharePage() {
    // 跳转到小程序分享页面
    const broadcastId = getUrlParam("broadcastId");
    const origin = getUrlParam("origin");
    // 如果是从独立版小麦秀小程序进入的分享页,那么分享的时候就跳到独立版小麦秀的分享页
    if (origin === "ordinary") {
      window.wx.miniProgram.redirectTo({
        url: `/pages/activity/activityShare/main?id=${broadcastId}&parentUid=${this.urlUid}`
      });
    } else {
      const posterName = this.posterName;
      window.wx.miniProgram.redirectTo({
        url: `/pages/user-share/index?broadcastId=${broadcastId}&parentUid=${this.urlUid}&name=${posterName}`
      });
    }
  }
}
